import axios from 'axios';

interface WelcomeFormData {
    name: string;
    email: string;
    country: string;
}

interface WelcomeResponse {
    success: boolean;
    message: string;
    data?: any;
}

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rwa.blocsys.com';
const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/blocsys';

export const welcomePopupService = {
    async submitWelcomeForm(
        formData: WelcomeFormData
    ): Promise<WelcomeResponse> {
        try {
            const response = await axios.post(
                `${API_BASE_URL}welcome/demo-request`,
                {
                    ...formData,
                    source: 'RWA-Platform',
                    timestamp: new Date().toISOString(),
                }
            );

            return {
                success: true,
                message:
                    'Thank you! We will contact you soon to schedule your demo.',
                data: response.data,
            };
        } catch (error: any) {

            return {
                success: false,
                message:
                    error.response?.data?.message ||
                    'Something went wrong. Please try again.',
                data: error.response?.data,
            };
        }
    },

    async sendWelcomeEmail(
        formData: WelcomeFormData
    ): Promise<WelcomeResponse> {
        try {
            const response = await axios.post(
                `${API_BASE_URL}welcome/send-email`,
                {
                    ...formData,
                    template: 'welcome_demo_request',
                    subject: 'Welcome to BlocEstate - Demo Request',
                }
            );

            return {
                success: true,
                message: 'Welcome email sent successfully!',
                data: response.data,
            };
        } catch (error: any) {

            return {
                success: false,
                message: 'Failed to send welcome email.',
                data: error.response?.data,
            };
        }
    },

    openCalendlyLink(): void {
        // Open Calendly link in a new tab
        window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer');
    },
};
